module.exports = __webpack_public_path__ + "static/media/infomx logo.0b294359.png";